/** Aurora background — 4 fixed radial-gradient blobs pinned to the viewport. */
export function Aurora() {
  return <div className="aurora-bg" aria-hidden="true" />;
}

export default Aurora;
